// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"411":"ab7c5fd9","925":"2b40df2f"}[chunkId] + ".chunk.js";
};